import {twMerge} from '@sdox/utils'

import type {ClassNameValue} from 'tailwind-merge'
import type {ReactNode} from 'react'

export interface BannerProps {
  //  A CTA or button
  action?: ReactNode
  // url of background image
  // when background image cannot be loaded, the scrim will be the background color
  backgroundImage?: string
  //  The Banner container className for simple overwrite
  className?: ClassNameValue
  //  A text/title
  heading: ReactNode
}

// v1.2
export const Banner = ({backgroundImage, heading, action, className}: BannerProps) => (
  <div className={'@container/block'}>
    {/* The background image has its own div, so we can put backdrop-blur-1 on the child div in a later iteration*/}
    <div
      className={'pullout-rounded-lg overflow-hidden bg-cover bg-center bg-no-repeat'}
      style={{
        backgroundImage: backgroundImage ? `url(${backgroundImage})`: undefined,
      }}
    >
      <div
        className={twMerge(
          'flex flex-col items-start gap-spacing-32',
          'px-spacing-20 py-spacing-56 @block-large:p-block-large',
          'bg-scrim-primary/80',
          className,
        )}
      >
        {heading && (
          <h3 className={'text-h3-xs text-glyph-inversed-primary @block-large:text-h3'}>
            {heading}
          </h3>
        )}
        {action}
      </div>
    </div>
  </div>
)
